export const wrapElement = (target, element = 'div') => {
  const wrapper = document.createElement(element);
  target.parentNode.insertBefore(wrapper, target);
  wrapper.appendChild(target);
  return wrapper;
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/dom.js